"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var forms_1 = require("@angular/forms");
var ng2_collapsable_component_1 = require("./ng2-collapsable.component");
var Ng2CollapsableModule = (function () {
    function Ng2CollapsableModule() {
    }
    return Ng2CollapsableModule;
}());
Ng2CollapsableModule = __decorate([
    core_1.NgModule({
        imports: [common_1.CommonModule, forms_1.FormsModule],
        declarations: [ng2_collapsable_component_1.Ng2CollapsableComponent],
        exports: [ng2_collapsable_component_1.Ng2CollapsableComponent]
    }),
    __metadata("design:paramtypes", [])
], Ng2CollapsableModule);
exports.Ng2CollapsableModule = Ng2CollapsableModule;
//# sourceMappingURL=ng2-collapsable.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-collapsable/dist/ng2-collapsable.module.js
// module id = 66
// module chunks = 0